import * as yup from 'yup';

export const getCompaniesFilterSchema = yup.object().shape({
  // domains: yup.array().of(yup.string()),
  fieldsOfActivity: yup.array().of(yup.string()),
  region: yup.string(),
  department: yup.string(),
});
